/**
 * @since 0.14.0
 * @component
 */

const BREAKPOINTS = {
  XS: [0, 767],
  SM: [768, 999],
  MD: [1000, 1139],
  LG: [1140, 1439],
  LL: [1360, 1439],
  XL: [1440, 1599],
  XXL: [1600],
} as const;

export type Breakpoints = {
  -readonly [P in keyof typeof BREAKPOINTS]?: [number, number?]
};

export default BREAKPOINTS as unknown as Breakpoints;
